import { useField } from 'formik'
import { BrandPlanTactic } from 'types'
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup'
import Styles from './CrosspostTactics.module.scss'
import cx from 'classnames'
import { TacticCheckbox } from './TacticCheckbox'
import { ComingSoonTacticCheckbox } from './ComingSoonTacticCheckbox'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useCallback } from 'react'
import { Google } from 'blaze-ui/icons'

interface PaidAdsTacticsProps {
  className?: string
  applyRedesign?: boolean
  hideComingSoon?: boolean
}

export const PaidAdsTactics = ({
  className,
  applyRedesign = false,
  hideComingSoon = false,
}: PaidAdsTacticsProps = {}) => {
  const isOnboardingRedesign = applyRedesign
  const [{ value }, , { setValue }] = useField<BrandPlanTactic[]>('tactics')

  const onChange = useCallback(
    (value: string[]) => {
      setValue(value as BrandPlanTactic[])
    },
    [setValue],
  )

  return (
    <CheckboxGroup
      value={value}
      onChange={onChange}
      className={cx(Styles.group, className, { [Styles.applyRedesign]: isOnboardingRedesign })}
      aria-label="Paid ads platforms"
    >
      <TacticCheckbox
        provider={ExternalIntegrationEnum.MetaAds}
        label="Meta"
        applyRedesign={applyRedesign}
        value={BrandPlanTactic.MetaAds}
        isDisabled={!value.includes(BrandPlanTactic.MetaAds)}
        onCancel={() => setValue(value)}
      />
      {!hideComingSoon && <ComingSoonTacticCheckbox icon={Google} label="Google" applyRedesign={applyRedesign} />}
    </CheckboxGroup>
  )
}
